var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.observable` well-known symbol
// https://github.com/tc39/proposal-observable
defineWellKnownSymbol('observable');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/esnext.symbol.observable.js
// module id = 937
// module chunks = 3